import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import CartDrawer from './cart-drawer'
import FreeShippingBar from './free-shipping-bar'

class CartDrawerFreeShippingBarBlock extends BaseComponent {
  cartDrawer: Nullable<CartDrawer>

  constructor() {
    super()

    this.cartDrawer = this.closest('cart-drawer')
  }

  connectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.subscribe('update-nodes', this.handleCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe('update-nodes', this.handleCartUpdate)
    }
  }

  handleCartUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const bar = this.querySelector<FreeShippingBar>('free-shipping-bar')
    const newBar = node.querySelector<FreeShippingBar>('free-shipping-bar')

    if (!bar || !newBar) {
      return
    }

    const difference =
      newBar.getAttribute('data-free-shipping-difference') || ''
    const differencePercent = +(
      newBar.getAttribute('data-free-shipping-difference-percent') || 0
    )

    bar.updateProgressByDifference(difference, differencePercent)
  }
}

export default CartDrawerFreeShippingBarBlock
